import React from "react";

import { Attribute } from "@multiweb/reactComponents";
import { AttributeComponent } from "../../../components";

export const LOVShowAttrItemComponent: AttributeComponent = ({
    dataSourceKey,
    attributeName,
    title,
    hasBackgroundAttr = false,
    iconCode,
    record,
    dataSourceAttributeInfo,
    interactive,
}) => (
    <Attribute {...{ value: record?.[attributeName].value, type: dataSourceAttributeInfo?.type, dataSourceKey, attributeName, title, iconCode, hasBackgroundAttr, interactive }} ellipsis={false} />
);
